import React, { Component } from 'react'
import Slider from '@mui/material/Slider';

const marks = [
    {
        value: 25,
        label: '25m',
    },
    {
        value: 50,
        label: '50m',
    },
    {
        value: 75,
        label: '75m',
    },
    {
        value: 100,
        label: '100m',
    },
    {
        value: 125,
        label: '125m',
    },
    {
        value: 150,
        label: '150m',
    },
];

export default class Rangepicker extends Component {
    render() {
        return (
            <Slider
                aria-label="Restricted values"
                defaultValue={this.props.default}
                valueLabelDisplay="auto"
                step={25}
                marks={marks}
                min={25}
                max={150}
                onChangeCommitted={(e,newValue)=>this.props.onChange(newValue)}
            />
        )
    }
}
